import { Icon } from "@circle-react-shared/Icon";

import { t } from "@/i18n-js/instance";
import type { AvatarProps } from "@/react/components/SettingsApp/CommunityInbox/Sidebar/ChatList/Avatar";
import { Avatar } from "@/react/components/SettingsApp/CommunityInbox/Sidebar/ChatList/Avatar";

import type { BodyProps } from "./Body";
import { Body } from "./Body";

export interface ItemProps extends AvatarProps, BodyProps {
  currentParticipant: {
    id?: number;
    name?: string;
    avatarUrl?: string;
    muted?: boolean;
  };
  hasUnreadMessages: boolean;
}

export const Item = ({
  isDirect,
  otherParticipants,
  chatRoomName,
  timestamp,
  lastMessage,
  currentParticipant,
  hasUnreadMessages,
  currentCommunityMember,
  isPinned = false,
}: ItemProps) => (
  <div className="flex w-full items-start justify-between">
    <div
      className="flex items-center space-x-3"
      data-testid="direct-message-details"
    >
      <Avatar isDirect={isDirect} otherParticipants={otherParticipants} />
      <Body
        isDirect={isDirect}
        chatRoomName={chatRoomName}
        timestamp={timestamp}
        lastMessage={lastMessage}
        currentCommunityMember={currentCommunityMember}
        isPinned={isPinned}
      />
    </div>
    <div className="flex size-6 items-center justify-center">
      {currentParticipant.muted ? (
        <Icon
          type="16-bell-snooze"
          aria-label={t("header_v3.muted")}
          size={16}
          className="text-timestamp"
        />
      ) : (
        hasUnreadMessages && (
          <span className="bg-messaging-info-blue inline-block size-2 rounded-full" />
        )
      )}
    </div>
  </div>
);
